module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-mobile u-relative u-force-3d"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--5 u-relative u-force-3d u-zindex--1 u-fit-w"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-relative u-force-3d u-zindex--3 u-marg-x-auto u-w10of12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide__description u-color--white u-lheight--150p"
  }, [_vm._v("We cannot map the world alone. Sign-up and we'll keep you involved every step of the way as PRAX helps us build a new dimension.")]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xl u-marg-t-sm@sm"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_c('app-input-email', {
    staticClass: "c-home-slide--5__content-container__content__form-input u-relative u-force-3d u-marg-t-xs"
  })], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--6 u-relative u-force-3d u-zindex--1 u-fit-w u-bg--brand-primary"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-relative u-force-3d u-zindex--6 u-marg-x-auto u-flex u-flex-ai--center u-w10of12"
  }, [_c('app-socials-links', {
    staticClass: "u-marg-l-w2of12"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--0 u-relative u-force-3d u-zindex--1 u-fit-w"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-marg-x-auto u-w10of12"
  }, [_c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--0__title u-color--white u-lheight--150p"
  }, [_vm._v("\n                We're on a mission to map the world in 3D and everything in between. To enable a world where digital and physical become one, we need to help computers understand every MAP, OBJECT, and ACTION.\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--2 u-relative u-force-3d u-zindex--1 u-fit-w u-bg--white"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-relative u-force-3d u-zindex--3 u-marg-x-auto u-w10of12"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__image-top-container"
  }, [_c('img', {
    staticClass: "c-home-mobile__slide__image-top-container__image u-block u-marg-x-auto u-w1of3 u-w1of2@sm",
    attrs: {
      "src": "/static/images/prac-logotype-3d.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--2__title u-color--black t-fweight--semi-bold u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide--2__title--1"
  }, [_vm._v("Earn PRAX,")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide--2__title--2"
  }, [_c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("use PRAX")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide__description o-content u-lheight--150p u-color--black u-force-3d"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("In the beginning of blockchain, bitcoin could be earned in the thousands a day by mining with a personal computer. Now, the incentives have grown to support much more specialized equipment making it the most powerful computing network in the world.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("We have similar plans for PRAX will continue to add innovative uses that increase demand. As the uses grow, the incentives will too, bringing user growth and a need for better equipment. Drones, cars, satellites, and many other devices can and will contribute to this repository.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--1 u-relative u-force-3d u-zindex--1 u-fit-w"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide--1__bg-cover u-absolute u-pos-tl u-fit u-zindex--1"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide--1__filter u-absolute u-pos-tl u-fit u-zindex--2 u-bg--black-o50"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-relative u-force-3d u-zindex--3 u-marg-x-auto u-w10of12"
  }, [_c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--1__title u-color--white t-fweight--semi-bold u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide--1__title--1"
  }, [_vm._v("3D World = 3D Maps")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide__description o-content is-white u-relative u-marg-x-auto u-lheight--150p u-force-3d"
  }, [_c('p', [_c('span', {
    staticClass: "u-color--gray-lighter"
  }, [_vm._v("Mapping the world is not an easy task. It starts with people like us, out in the world, scanning in the places we visit the most. As incentives grow, more will join us,  and we will create a whole new dimension on top of this reality.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--3 u-relative u-force-3d u-zindex--1 u-fit-w"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-relative u-force-3d u-zindex--3 u-marg-x-auto u-w10of12"
  }, [_c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--3__title u-color--white t-fweight--semi-bold u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide--3__title--1"
  }, [_vm._v("We calculate")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide--3__title--2"
  }, [_c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("tokens")]), _vm._v(" from")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides u-color--white u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide c-home-mobile__slides__slide--1 o-content"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide__title"
  }, [_c('strong', [_vm._v("Map Location")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide__content"
  }, [_c('ul', {
    staticClass: "u-opacity--50"
  }, [_c('li', [_vm._v("Type (Public or Private)")]), _vm._v(" "), _c('li', [_vm._v("Traffic (Low, Medium, High)")]), _vm._v(" "), _c('li', [_vm._v("Reachability (Easy, Difficult)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide c-home-mobile__slides__slide--2 o-content"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide__title"
  }, [_c('strong', [_vm._v("Map Quality")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide__content"
  }, [_c('ul', {
    staticClass: "u-opacity--50"
  }, [_c('li', [_vm._v("Distinct Surfaces (Walls, Floor, Ceiling, Objects)")]), _vm._v(" "), _c('li', [_vm._v("Type of Surfaces (Structural, Static, Moveable)")]), _vm._v(" "), _c('li', [_vm._v("Gaps in Mesh (None, Few, Many)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide c-home-mobile__slides__slide--3 o-content"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide__title"
  }, [_c('strong', [_vm._v("Map Size")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide__content"
  }, [_c('ul', {
    staticClass: "u-opacity--50"
  }, [_c('li', [_vm._v("Area Mapped (Small, Large, Significant)")]), _vm._v(" "), _c('li', [_vm._v("Number of Areas (Single, Multiple)")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-mobile__slide c-home-mobile__slide--4 u-relative u-force-3d u-zindex--1 u-fit-w u-bg--white u-overflow-h"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide__wrapper u-relative u-force-3d u-zindex--3 u-marg-x-auto u-w10of12"
  }, [_c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--4__title u-color--black t-fweight--semi-bold u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide--4__title--1"
  }, [_vm._v("Uses for")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide--4__title--3 u-relative"
  }, [_c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("everyone")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides u-color--black u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide c-home-mobile__slides__slide--1 o-content"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide__title"
  }, [_c('strong', [_vm._v("Continuous Map Access")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide__content"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("In mixed reality, apps require 3D maps. We learned that it takes one (1) hour per 5500 sqft of floor space. That's 30 minutes for the average US home, or over 400 hours for a large stadium. PRAX enable continuous access to maps, meaning people can jump straight into their chosen application instead of taking time to map.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__experience u-relative u-overflow-h"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__experience__slide c-home-mobile__slides__experience__slide--1 u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__experience__slide c-home-mobile__slides__experience__slide--2 u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__experience__link u-relative t-ffamily--simplon u-color--white u-uppercase"
  }, [_vm._v("Download this map")])]), _vm._v(" "), _c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--4__title u-color--black t-fweight--semi-bold u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slide--4__title--1"
  }, [_vm._v("Enabling elegance")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slide--4__title--3 u-relative"
  }, [_vm._v("and "), _c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("beauty")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides u-color--black u-lheight--150p"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide c-home-mobile__slides__slide--2 o-content"
  }, [_c('div', {
    staticClass: "c-home-mobile__slides__slide__title"
  }, [_c('strong', [_vm._v("Time & Persistence")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-mobile__slides__slide__content"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("Practical will have a variety of time based services that require PRAX for operation. PRAX for persistence will allow holograms to come in and out of existence, aligning mixed reality towards elegance and beauty.")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "c-home-mobile__slide__title c-home-mobile__slide--5__title u-color--white u-lheight--150p t-fweight--light"
  }, [_c('div', [_vm._v("Ready, set")]), _vm._v(" "), _c('div', [_vm._v("map")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee9f696"}!./src/scripts/components/app-home-mobile/template.html
// module id = 456
// module chunks = 0